module.exports = __webpack_public_path__ + "static/media/wizard_3.f90f5ee5.png";